import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Name from "./Name";
import { getDobDate } from "../common/DisplayDate";

class InstantCriminal extends Component {
  componentDidMount() {}

  render() {
    const dob = getDobDate(_.get(this.props.node, "fulldob[0]._", ""), {
      userAccount: this.props.userAccount,
      isDobValue: true,
    });
    const category = _.get(this.props.node, "category[0]._", "");
    const state = _.get(this.props.node, "state[0]._", "");
    const sourceorjurisdiction = _.get(
      this.props.node,
      "sourceorjurisdiction[0]._",
      ""
    );
    return (
      <Table
        key={`InstantCriminal_Table_${this.props.index}`}
        className={`sub-table`}
      >
        <Table.Body>
          <Table.Row>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              Name:
            </Table.Cell>
            <Table.Cell width={3} className={"sub-table-cell"}>
              <Name
                node={this.props.node}
                handleNewSearchClick={this.props.handleNewSearchClick}
              />
            </Table.Cell>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              Date Of Birth:
            </Table.Cell>
            <Table.Cell width={3} className={"sub-table-cell"}>
              {dob}
            </Table.Cell>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              Category:
            </Table.Cell>
            <Table.Cell width={4} className={"sub-table-cell"}>
              {category}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>
              State:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>{state}</Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Source/Jurisdiction:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} colSpan={3}>
              {sourceorjurisdiction}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default InstantCriminal;



// WEBPACK FOOTER //
// ./src/components/searchresults/InstantCriminal.js